import { CalendarPlus02 } from '@untitled-ui/icons-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/components/ui/Button';
import ObjectItemDischargesModal from '@/features/objectItems/components/WasteCalendar/ObjectItemDischargesModal';

const AdditionalDischargesActionCard = () => {
  const { t } = useTranslation('desktopPage');

  const [isAdditionalDischargeModalOpen, setIsAdditionalDischargeModalOpen] = useState(false);

  const handleCloseDischargesModal = () => {
    setIsAdditionalDischargeModalOpen(false);
  };

  const handleOpenDischargesModal = () => {
    setIsAdditionalDischargeModalOpen(true);
  };

  return (
    <>
      <div className="bg-white h-[218px] sm:h-full flex flex-col justify-between rounded-[32px] sm:flex-1 p-5">
        <div className="flex mb-2 justify-between items-center">
          <span className="text-[20px] text-[#595959] font-bold">{t('additionalDischarges', { ns: 'header' })}</span>
          <CalendarPlus02 className="w-6 h-6 text-[#9C8B7E]" />
        </div>
        <Button onClick={handleOpenDischargesModal} variant="primary">
          {t('orderDischarge')}
        </Button>
      </div>

      <ObjectItemDischargesModal isModalOpen={isAdditionalDischargeModalOpen} handleCancel={handleCloseDischargesModal} />
    </>
  );
};

export default AdditionalDischargesActionCard;
